import { Directive, ElementRef, Input, OnInit } from '@angular/core';
import { JwtHelper } from 'angular2-jwt';
import { OauthHelper } from '../../services';
import { accessControlConfig } from "../../../../config/access-control.config";

@Directive({
	selector: '[hasFeatureAccess]'
})
export class HasFeatureAccessDirective implements OnInit {
	@Input('hasFeatureAccess') featureKey: string;

	constructor(
		private el: ElementRef,
		private jwtHelper: JwtHelper,
		private oauthHelper: OauthHelper
	) {
		this.el.nativeElement.style.display = 'none';
	}

	ngOnInit() {
		const accessToken = this.oauthHelper.getAccessToken();
		if (!accessToken) {
			this.removeElement();
			return;
		}

		const decodedToken = this.jwtHelper.decodeToken(accessToken);
		const userMerchantId = decodedToken.merchantId;
		const userRoles: string[] = decodedToken.authorities || [];
		const config = accessControlConfig[this.featureKey];
		if (!config) {
			this.removeElement();
			return;
		}

		if (config.merchantIds.indexOf(userMerchantId) >= 0) {
			this.el.nativeElement.style.display = '';
			return;
		}

		for (const role of config.roles || []) {
			const fullRole = `ROLE_${role}`;
			if (userRoles.indexOf(fullRole) >= 0) {
				this.el.nativeElement.style.display = '';
				return;
			}
		}

		this.removeElement();
	}

	private removeElement() {
		const parent = this.el.nativeElement.parentNode;
		if (parent) {
			parent.removeChild(this.el.nativeElement);
		}
	}
}




// WEBPACK FOOTER //
// ./src/app/ui-helper/hasFeatureAccess/has-feature-access.directive.ts